export const buttonStyles = (data, grefs) => {
  const buttonPanelstyle = {
    display: "flex",
    justifyContent: "center",
    gap: data.buttonStyle.gap,
    marginTop: 20,
  };

  const buttonStyle = {
    fontSize: data.buttonStyle.fontSize,
    fontWeight: data.buttonStyle.fontWeight,
    border: `${data.buttonStyle.border.width}px solid ${data.buttonStyle.border.color}`,
    borderRadius: data.buttonStyle.border.radius,
    paddingTop: data.buttonStyle.padding.vertical,
    paddingBottom: data.buttonStyle.padding.vertical,
    paddingLeft: data.buttonStyle.padding.horizontal,
    paddingRight: data.buttonStyle.padding.horizontal,
    cursor: "pointer",
  };

  const yesbuttonStyle =
    data.type === "question" && !(data.id in grefs.questionsWithoutYes.current)
      ? {
          ...buttonStyle,
          backgroundColor: data.buttonStyle.yes.backgroundColor,
          color: data.buttonStyle.yes.color,
        }
      : { display: "none" };
  const nobuttonStyle =
    data.type === "question" && !(data.id in grefs.questionsWithoutNo.current)
      ? {
          ...buttonStyle,
          backgroundColor: data.buttonStyle.no.backgroundColor,
          color: data.buttonStyle.no.color,
        }
      : { display: "none" };

  const nextbuttonStyle =
    data.type === "question" || data.type === "select"
      ? { display: "none" }
      : {
          ...buttonStyle,
          backgroundColor: data.buttonStyle.next.backgroundColor,
          color: data.buttonStyle.next.color,
        };

  return {
    yes: yesbuttonStyle,
    no: nobuttonStyle,
    panel: buttonPanelstyle,
    next: nextbuttonStyle,
  };
};
export const handleStyles = () => {
  const handleDimension = 20;

  const handleStyle = {
    position: "absolute",
    height: handleDimension,
    width: handleDimension,
    border: "1px solid blue",
    backgroundColor: "orange",
    cursor: "pointer",
  };

  return {
    Top: { ...handleStyle, left: "50%", transform: "translate(-50%, 0%)" },
    Right: {
      ...handleStyle,
      top: "50%",
      right: 0,
      transform: "translate(0%, -50%)",
    },
    Left: {
      ...handleStyle,
      top: "50%",
      left: 0,
      transform: "translate(0%, -50%)",
    },
    Bottom: {
      ...handleStyle,
      left: "50%",
      bottom: 0,
      transform: "translate(-50%, 0%)",
    },
  };
};

export const handleStyle = (data, grefs, type) => {
  const isHidden =
    type === "source"
      ? data.id in grefs.selectedRef.current
        ? false
        : true
      : false;
  return {
    backgroundColor: isHidden
      ? "transparent"
      : data.handleStyle.backgroundColor,
    opacity: isHidden ? 0 : 1,
    // height: 20,
    // width: 20,
    // borderRadius: 2,
    // border: "1px solid black",
  };
};
